import { z } from "zod";
import { ReportExecutionHistoryColumnDtoSchema } from "./ReportExecutionHistoryColumnDto";
import { ReportExecutionHistoryDataDtoSchema } from "./ReportExecutionHistoryDataDto";


export const ReportExecutionHistoryDownloadDtoSchema = z.object({
    id: z.string(),
    reportId: z.number(),
    executionStartTime: z.string().nullable(),
    executionEndTime: z.string().nullable(),
    executedByUserId: z.string(),
    expirationDate: z.string().nullable(),
    isExpired: z.boolean(),
    group: z.string().nullable(),
    reportExecutionHistoryColumns: z.array(ReportExecutionHistoryColumnDtoSchema),
    reportExecutionHistoryData: z.array(ReportExecutionHistoryDataDtoSchema),
});